import React, { useCallback, useState } from 'react';
import { connect } from "react-redux";
import OMTransactionSearchForm from './OMTransactionSearchForm.js';
import DxTabPanel, { Item } from "devextreme-react/tab-panel";
import { useHistory, useParams } from 'react-router-dom';
import OMTransactionsMain from './OMTransactionsMain.js';
import '../../common/css/searchPage.css';
const tabs = [
  {
    ID: 1,
    Title: 'Quote'
  },
  {
    ID: 2,
    Title: 'Order'
  },
];
const OMTransaction = (props) => {
  const history = useHistory();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const onTabSelectionChanged = useCallback((e) => {
    if (e.fullName === 'selectedIndex') {
      setSelectedTabIndex(e.value);
      history.push('/om/transaction');
    }
  }, []);
  const [filteredTabs, setFilteredTabs] = useState(tabs);
  return (
    <div className="search-page-container">
      <DxTabPanel
        key={selectedTabIndex} 
        onOptionChanged={onTabSelectionChanged} 
        selectedIndex={selectedTabIndex}
        style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
      >
        {filteredTabs.map((m, i) => (
          <Item key={i} title={m.Title}>
            <OMTransactionsMain selectedTab = {m.Title} />
          </Item>
        ))}
      </DxTabPanel>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(OMTransaction);